import { render, staticRenderFns } from "./BehaviorBarChart.vue?vue&type=template&id=6d56f080&scoped=true"
import script from "./BehaviorBarChart.vue?vue&type=script&lang=js"
export * from "./BehaviorBarChart.vue?vue&type=script&lang=js"
import style0 from "./BehaviorBarChart.vue?vue&type=style&index=0&id=6d56f080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56f080",
  null
  
)

export default component.exports